import React from "react";
import QuoteComparisonReport from "../QuoteComparisonReport";
import { RateAnalysis, QuoteRequest } from "../../types/rate-analysis";

interface QuoteGradingResultsProps {
  analysis: RateAnalysis;
  quoteRequest: QuoteRequest;
}

const QuoteGradingResults: React.FC<QuoteGradingResultsProps> = ({
  analysis,
  quoteRequest,
}) => {
  return (
    <>
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4">
          Your Refinance Analysis
        </h1>
      </div>

      <QuoteComparisonReport
        analysis={analysis}
        quoteRequest={quoteRequest}
        gradeTitle="Your Quote Grade"
      />
    </>
  );
};

export default QuoteGradingResults;
